import React, { useEffect, useState } from 'react'
import {
    Table,
    Space,
    Tooltip,
    Modal,
    Drawer,
    Button,
    Tag,
    Popover,
} from 'antd'
import commonStyles from '../../../Utils/Common.less'
import type { ColumnsType, TableProps } from 'antd/es/table'
import {
    UnorderedListOutlined,
    CommentOutlined,
    MailOutlined,
    MessageOutlined,
    PhoneOutlined,
    UserSwitchOutlined,
    HistoryOutlined,
    DeleteOutlined,
    PauseOutlined,
    CalendarOutlined,
    PlayCircleOutlined,
    InfoCircleTwoTone,
} from '@ant-design/icons'
import style from '../tingtodo.less'
import {
    type PinedMessage,
    type ThingsTodoTableList,
    type VatPageProps,
} from '../../../Types/ToDoViewAllList'
import calculatePagination from '../../../Utils/Pagination'
import SearchInput from '../../../Components/SearchInput'
import StaffCommunication from '../CommunicationModel/staffCommunication'
import { useNavigate } from 'react-router-dom'
import ServiceProcessHistory from '../ProcessModel/serviceProcessHistoryModel'
import CommunicationHistory from '../CommunicationModel/CommunicationHistory'
import ToDoPhoneCallModel from '../CommunicationModel/phoneCallModel'
import SMSModelPage from '../CommunicationModel/smsModel'
import MailTempalteModel from '../CommunicationModel/mailModel'
import SwitchUserPage from '../CommunicationModel/switchUserModel'
import { ReactComponent as Invoice } from '../../../Assest/Svg/invoice.svg'
import InvoiceModel from '../ProcessModel/invoiceModel'
import HoldThisProcess from '../ProcessModel/HoldProcessModel'
import VoidThisProcess from '../ProcessModel/voidthisProcessModel'
import ChangeDueDateModel from '../ProcessModel/changedueDateModel'
import { useDispatch } from 'react-redux'
import { servicedataId } from '../../../Reducer/DashboardFlagReducer'
import { FORMAT_DATE } from '../../../Utils/dateFormat'
import { ReactComponent as Pin } from '../../../Assest/Svg/Pinoutline.svg'
import { type DataCHAT } from '../../../Types/Client/ProspectClients/prospectClient'
import ProcessRemarks from '../ProcessModel/processRemarksModel'
import { GetPinnedChat } from '../../../Services/ToDoViewAllList'
import ActivePremission from '../../../Utils/premissins'
import { PermissionType } from '../../../Types/Enum/PermissionType'
import {
    serviceProcessDetailsList,
    serviceProcessInduvidualData,
} from '../../../Reducer/DashboardReducer'
const ConformationStatement = (props: VatPageProps): React.ReactElement => {
    const {
        thingsTodoList,
        thingsTodoListCount,
        setPagesize,
        setPageNumber,
        taskViewId,
        serviceId,
        id,
        setSearchString,
        statusId,
        updateRefetchData,
    } = props
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [Historymodel, setHistorymodel] = useState(false)
    const [serviceProcessId, setServiceProcessId] = useState<number>(0)
    const [open, setOpen] = useState(false)
    const [chatData, setProcessChatData] = useState<DataCHAT | null>(null)
    const [comHistorymodel, setCommunicationHistorymodel] = useState(false)
    const [selectedButtonId, setSelectedButtonId] = useState<number | null>(
        null
    )
    const [PhoneCallModel, setPhoneCallmodel] = useState(false)
    const [SMSModel, setSMSmodel] = useState(false)
    const [mailmodel, setMailmodel] = useState(false)
    const [switchUserModel, setSwitchUserModel] = useState(false)
    const [invoiceModel, setInvoiceModel] = useState(false)
    const [voidThisModel, setVoidThisModel] = useState(false)
    const [holdThisModel, setholdThisModel] = useState(false)
    const [serviceFlagId, setServicFlagId] = useState('')
    const [referenceId, setReferenceId] = useState(0)
    const [businessTypeId, setBusinessTypeId] = useState(0)
    const [changeDueDateModel, setchangeDueDateModel] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [searchData, setSearchData] = useState('')
    const [remarksModel, setRemarksModel] = useState(false)
    const [auditdata, setAuditData] = useState<PinedMessage | null>(null)
    const [restData, setDataReset] = useState('false')

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    useEffect(() => {
        setPagesize(itemsPerPage)
        setPageNumber(currentPage)
        setSearchString(searchData)
    }, [currentPage, itemsPerPage, searchData])

    useEffect(() => {
        const fetchAuditData = async (): Promise<void> => {
            try {
                if (serviceProcessId !== 0) {
                    const data = await GetPinnedChat(dispatch, serviceProcessId)
                    setAuditData(data)
                }
            } catch (error) {
                console.error('Error fetching audit data:', error)
            }
        }
        void fetchAuditData()
    }, [serviceProcessId])
    useEffect(() => {
        setCurrentPage(1)
        setItemsPerPage(10)
    }, [statusId])
    const handlePageChange = (pageNo: number, pageSize: number): void => {
        window.scrollTo(0, 0)
        setCurrentPage(pageNo)
        setItemsPerPage(pageSize)
    }
    const handlePageSizeChange = (pageSize: number): void => {
        setItemsPerPage(pageSize)
        setCurrentPage(1) // Reset to first page when page size changes
    }
    const pagination = calculatePagination(
        currentPage,
        thingsTodoListCount,
        itemsPerPage,
        handlePageSizeChange
    )

    const openHistoryModel = (id: number): void => {
        setServiceProcessId(id)
        setCommunicationHistorymodel(!comHistorymodel)
    }

    const changeCommunictionHistoryModalStatus = (): void => {
        setSelectedButtonId(null)
        setCommunicationHistorymodel(!comHistorymodel)
    }

    const openPhoneCallModel = (id: number, bIds: number): void => {
        setBusinessTypeId(bIds)
        setServiceProcessId(id)
        setPhoneCallmodel(!PhoneCallModel)
        setDataReset('true')
    }

    const changePhoneCallModalStatus = (): void => {
        setPhoneCallmodel(!PhoneCallModel)
    }

    const openSMSModel = (id: number): void => {
        setServiceProcessId(id)
        setSMSmodel(!SMSModel)
        setDataReset('true')
    }

    const changeSMSModalStatus = (): void => {
        setSMSmodel(!SMSModel)
    }

    const openMailModel = (
        serviceProcessId: number,
        referenceId: number
    ): void => {
        setServiceProcessId(serviceProcessId)
        setMailmodel(!mailmodel)
        setDataReset('true')
        setReferenceId(referenceId)
    }

    const changeMailModalStatus = (): void => {
        setMailmodel(!mailmodel)
    }

    const openSwitchUserModel = (serviceProcessId: number): void => {
        setServiceProcessId(serviceProcessId)
        setSwitchUserModel(!switchUserModel)
    }

    const changeSwitchUserModalStatus = (): void => {
        setSwitchUserModel(!switchUserModel)
    }

    const openInvoiceModel = (
        serviceProcessId: number,
        referenceId: number
    ): void => {
        setServiceProcessId(serviceProcessId)
        setReferenceId(referenceId)
        setInvoiceModel(!invoiceModel)
        setDataReset('true')
    }

    const changeInvoiceModalStatus = (): void => {
        setInvoiceModel(!invoiceModel)
    }

    const openViodModel = (serviceProcessId: number): void => {
        setServiceProcessId(serviceProcessId)
        setVoidThisModel(!voidThisModel)
    }

    const changeVoidModalStatus = (): void => {
        setVoidThisModel(!voidThisModel)
    }
    const openHoldModel = (serviceProcessId: number, flagid: string): void => {
        setServiceProcessId(serviceProcessId)
        setServicFlagId(flagid)
        setholdThisModel(!holdThisModel)
    }

    const changeHoldModalStatus = (): void => {
        setholdThisModel(!holdThisModel)
    }

    const openChangeDuedateModel = (serviceProcessId: number): void => {
        setServiceProcessId(serviceProcessId)
        setchangeDueDateModel(!changeDueDateModel)
        setDataReset('true')
    }

    const ChengeDueDateModelClose = (): void => {
        setchangeDueDateModel(!changeDueDateModel)
    }
    const columns: ColumnsType<ThingsTodoTableList> = [
        {
            title: 'Number',
            dataIndex: 'clientNumber',
        },
        {
            title: 'Client',
            key: 'clientName',
            render: (_, record) => {
                return (
                    <div>
                        {record.clientName}{' '}
                        {record.additionalDataTwo === '1' && (
                            <Tag bordered={false} color="blue">
                                Invoiced
                            </Tag>
                        )}
                        <br /> Next statement date{' '}
                        {FORMAT_DATE(record.periodStartDate)} due by{' '}
                        {FORMAT_DATE(record.periodEndDate)}
                        <br />
                        {statusId === 1 ? (
                            <span style={{ color: 'red' }}>
                                {record.dueDays === 1
                                    ? 'Yesterday was the last due date to submit the file'
                                    : `${record.dueDays} days passed from due date to
                                submit the file`}
                            </span>
                        ) : statusId === 0 ? (
                            <span
                                style={{
                                    color:
                                        record.dueDays > 10
                                            ? `green`
                                            : `#f9d35d`,
                                }}
                            >
                                {record.dueDays === 0
                                    ? 'Today is the last due date to submit the file'
                                    : record.dueDays === 1
                                      ? 'Tomorrow is the last due date to submit the file'
                                      : record.dueDays <= 10
                                        ? `${record.dueDays}  days more to submit the file`
                                        : `${record.dueDays}  days more to submit the file`}
                            </span>
                        ) : (
                            ''
                        )}
                        {statusId !== 2 &&
                            record?.processDueDate !== '1900-01-01' && (
                                <>
                                    {' '}
                                    <br />
                                    {record.dueDateProgressStatus === 1 ? (
                                        <span
                                            style={{
                                                color:
                                                    record.assignDueDays > 10
                                                        ? 'green'
                                                        : '#f9d35d',
                                            }}
                                        >
                                            {record.assignDueDays === 0
                                                ? 'Today is the last due date to submit the file'
                                                : record.assignDueDays === 1
                                                  ? 'Tomorrow is the last due date to submit the file'
                                                  : `${record.assignDueDays} days more to submit the file`}
                                        </span>
                                    ) : (
                                        <span style={{ color: 'red' }}>
                                            {record.assignDueDays === 1
                                                ? 'Yesterday was the last due date to submit the file'
                                                : `${record.assignDueDays} days passed from due date to submit the file`}
                                        </span>
                                    )}
                                    <br />
                                    {record?.dueDateDescription !== '' &&
                                        record.dueDateDescription !== null && (
                                            <Popover
                                                placement="top"
                                                title="Remarks"
                                                content={
                                                    record.dueDateDescription
                                                }
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <InfoCircleTwoTone />
                                            </Popover>
                                        )}
                                </>
                            )}
                    </div>
                )
            },
        },

        ...(statusId !== 2
            ? [
                  {
                      width: 250,
                      title: 'Assign Info',
                      key: 'assignTo',
                      render: (record: ThingsTodoTableList) => {
                          return (
                              <div>
                                  Assign by : {record.assignBy} <br /> Assign to
                                  : {record.assignTo} <br /> Assign Date :{' '}
                                  {FORMAT_DATE(record.assignDate)}
                                  <br />
                                  {id === 2 && taskViewId === 1 && (
                                      <Tooltip title={'Change Due Date'}>
                                          <CalendarOutlined
                                              onClick={() => {
                                                  openChangeDuedateModel(
                                                      record.serviceProcessId
                                                  )
                                              }}
                                          />
                                      </Tooltip>
                                  )}
                              </div>
                          )
                      },
                  },
              ]
            : []),

        {
            title: 'Action Status',
            key: 'action',
            render: (record: ThingsTodoTableList) => {
                return (
                    <>
                        {statusId !== 2 ? (
                            <>
                                <div>{record.actionName}</div>
                                <div>
                                    {record.currentStatus === 'In Review' ||
                                    record.currentStatus ===
                                        'Pending Approval' ? (
                                        <Tag bordered={false} color="red">
                                            {record.currentStatus}
                                        </Tag>
                                    ) : record.currentStatus === 'Complete' ? (
                                        <Tag bordered={false} color="green">
                                            {record.currentStatus}
                                        </Tag>
                                    ) : (
                                        <Tag bordered={false} color="orange">
                                            {record.currentStatus}
                                        </Tag>
                                    )}
                                </div>
                                <Space size="middle">
                                    <Tooltip title="Service Process">
                                        <Button
                                            type="primary"
                                            size="small"
                                            onClick={() => {
                                                const serviceprocessId =
                                                    record.serviceProcessId

                                                dispatch(
                                                    servicedataId({
                                                        serviceProcesssId:
                                                            serviceprocessId,
                                                        serviceId:
                                                            serviceId ?? 0,
                                                        modeId: id ?? 1,
                                                        reviewerId:
                                                            record.reviewerId ??
                                                            0,
                                                        assignedToBeforeReview:
                                                            record.assignTo,
                                                        assignedDateBeforeReview:
                                                            record.assignDate,
                                                    })
                                                )
                                                const servicedataIds = {
                                                    serviceProcesssId:
                                                        serviceprocessId ?? 0,
                                                    serviceId: serviceId ?? 0,
                                                    modeId: id ?? 1,
                                                    reviewerId:
                                                        record.reviewerId ?? 0,
                                                    assignedToBeforeReview:
                                                        record.assignTo,
                                                    assignedDateBeforeReview:
                                                        record.assignDate,
                                                }
                                                localStorage.setItem(
                                                    'servicedataId',
                                                    JSON.stringify(
                                                        servicedataIds
                                                    )
                                                )
                                                navigate(
                                                    id === 1
                                                        ? `/thing-to-do/service-process`
                                                        : `/Things-to-Follow/service-process`
                                                )
                                                dispatch(
                                                    serviceProcessInduvidualData(
                                                        {
                                                            data: null,
                                                        }
                                                    )
                                                )
                                                dispatch(
                                                    serviceProcessDetailsList({
                                                        data: [],
                                                    })
                                                )
                                            }}
                                        >
                                            Process
                                        </Button>
                                    </Tooltip>
                                    {record.additionalDataOne === '1' &&
                                        record.additionalDataTwo === '1' && (
                                            <Tooltip title="Click To Hold">
                                                <PauseOutlined
                                                    onClick={() => {
                                                        openHoldModel(
                                                            record.serviceProcessId,
                                                            record.additionalDataTwo
                                                        )
                                                    }}
                                                    className={
                                                        commonStyles.clickableIcon
                                                    }
                                                />
                                            </Tooltip>
                                        )}
                                    {record.additionalDataOne === '1' &&
                                        record.additionalDataTwo === '7' && (
                                            <Tooltip
                                                title={`${record.additionalDataThree}-Click to resume`}
                                            >
                                                <PlayCircleOutlined
                                                    onClick={() => {
                                                        openHoldModel(
                                                            record.serviceProcessId,
                                                            record.additionalDataTwo
                                                        )
                                                    }}
                                                    className={
                                                        commonStyles.clickableIcon
                                                    }
                                                />
                                            </Tooltip>
                                        )}

                                    <Tooltip title="Staff Communication">
                                        <CommentOutlined
                                            onClick={() => {
                                                showDrawer(
                                                    record.serviceProcessId,
                                                    record.clientName,
                                                    `Next accounts made up to
                                                
                                                ${record.periodStartDate} due by
                                                ${record.periodEndDate}
                                                `
                                                )
                                            }}
                                            className={
                                                commonStyles.clickableIcon
                                            }
                                        />
                                    </Tooltip>
                                    {taskViewId === 1 && (
                                        <>
                                            <Tooltip title={'Switch User'}>
                                                <UserSwitchOutlined
                                                    onClick={() => {
                                                        openSwitchUserModel(
                                                            record.serviceProcessId
                                                        )
                                                    }}
                                                    className={
                                                        commonStyles.clickableIcon
                                                    }
                                                />
                                            </Tooltip>
                                            {record.additionalDataFour ===
                                                '0' && (
                                                <Tooltip
                                                    title={'Generate Invoice'}
                                                >
                                                    <Invoice
                                                        className={
                                                            style.invoice
                                                        }
                                                        onClick={() => {
                                                            openInvoiceModel(
                                                                record.serviceProcessId,
                                                                record.referenceId
                                                            )
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                            {ActivePremission(
                                                '4002',
                                                PermissionType.DELETE
                                            ) && (
                                                <Tooltip
                                                    title={'Void This Process'}
                                                >
                                                    <DeleteOutlined
                                                        className={
                                                            style.invoice
                                                        }
                                                        onClick={() => {
                                                            openViodModel(
                                                                record.serviceProcessId
                                                            )
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </>
                                    )}

                                    <Tooltip title="Service Process History">
                                        <UnorderedListOutlined
                                            onClick={() => {
                                                onHistoryModelOpen(
                                                    record.serviceProcessId
                                                )
                                            }}
                                            className={
                                                commonStyles.clickableIcon
                                            }
                                        />
                                    </Tooltip>
                                </Space>
                            </>
                        ) : (
                            <>
                                {record?.completeDate !== null && (
                                    <div>
                                        Completed on {record?.completeDate}
                                    </div>
                                )}
                                <Tooltip title="Service Process History">
                                    <UnorderedListOutlined
                                        onClick={() => {
                                            onHistoryModelOpen(
                                                record.serviceProcessId
                                            )
                                        }}
                                        className={commonStyles.clickableIcon}
                                    />
                                </Tooltip>
                            </>
                        )}
                    </>
                )
            },
        },
        ...(taskViewId === 1
            ? [
                  {
                      title: 'Communication',
                      key: 'action',

                      render: (record: ThingsTodoTableList) => {
                          return (
                              <Space size="middle" direction="vertical">
                                  <span style={{ display: 'block' }}>
                                      {record.lastCommunicationStatus}
                                  </span>

                                  <Space size="middle">
                                      <Tooltip title="Communication History">
                                          <HistoryOutlined
                                              onClick={() => {
                                                  openHistoryModel(
                                                      record.serviceProcessId
                                                  )
                                              }}
                                              className={
                                                  commonStyles.clickableIcon
                                              }
                                          />
                                      </Tooltip>
                                      {statusId !== 2 && (
                                          <>
                                              <Tooltip title="Send Mail">
                                                  <MailOutlined
                                                      onClick={() => {
                                                          openMailModel(
                                                              record.serviceProcessId,
                                                              record.referenceId
                                                          )
                                                      }}
                                                      className={
                                                          commonStyles.clickableIcon
                                                      }
                                                  />
                                              </Tooltip>
                                              <Tooltip title="Send SMS">
                                                  <MessageOutlined
                                                      onClick={() => {
                                                          openSMSModel(
                                                              record.serviceProcessId
                                                          )
                                                      }}
                                                      className={
                                                          commonStyles.clickableIcon
                                                      }
                                                  />
                                              </Tooltip>
                                              <Tooltip title="Phone Calls">
                                                  <PhoneOutlined
                                                      onClick={() => {
                                                          openPhoneCallModel(
                                                              record.serviceProcessId,
                                                              record.businessTypeId
                                                          )
                                                      }}
                                                      className={
                                                          commonStyles.clickableIcon
                                                      }
                                                  />
                                              </Tooltip>
                                          </>
                                      )}
                                  </Space>
                              </Space>
                          )
                      },
                  },
              ]
            : []),
    ]

    const onChangeTableParams: TableProps<ThingsTodoTableList>['onChange'] = (
        pagination,
        filters,
        sorter: any,
        extra
    ) => {
        handlePageChange(pagination.current ?? 1, pagination.pageSize ?? 10)
    }

    const onChangeText = (data: string): void => {
        if (data?.length === 0) {
            onChangeFilter('')
        } else {
            onChangeFilter(data)
        }
    }

    const onChangeFilter = (data: string): void => {
        setSearchData(data)
    }

    const onHistoryModelOpen = (serviceprocesId: number): void => {
        setHistorymodel(!Historymodel)
        setServiceProcessId(serviceprocesId)
    }
    const changeHistoryModalStatus = (): void => {
        setServiceProcessId(0)
        setHistorymodel(!Historymodel)
    }

    const showDrawer = (
        id: number,
        name: string,
        dateDetails: string
    ): void => {
        setServiceProcessId(id)
        setOpen(true)
    }

    const onClose = (): void => {
        setOpen(false)
    }

    const changeRemarksModalStatus = (): void => {
        setRemarksModel(!remarksModel)
    }

    const openRemarksModel = (serviceProcessId: number): void => {
        setServiceProcessId(serviceProcessId)
        setRemarksModel(!remarksModel)
    }

    const mappedData: ThingsTodoTableList[] = thingsTodoList.map(
        (item, index) => ({
            ...item,
            key: index,
        })
    )
    return (
        <>
            <SearchInput
                placeHolder={'Search by keywords'}
                onSearch={onChangeFilter}
                onChange={onChangeText}
                width="478"
            />
            <div className={commonStyles.table}>
                {thingsTodoListCount > 0 ? (
                    <Table
                        columns={columns}
                        onChange={onChangeTableParams}
                        dataSource={mappedData}
                        pagination={pagination}
                    />
                ) : (
                    <div>No Record Found</div>
                )}
            </div>
            <Modal
                footer={null}
                onCancel={changeHistoryModalStatus}
                width={'60%'}
                title={'Service Process History'}
                open={Historymodel}
            >
                <ServiceProcessHistory
                    serviceprocessId={serviceProcessId}
                    serviceId={serviceId}
                />
            </Modal>
            <Drawer
                title={
                    <div>
                        <>{chatData?.clientName}</>
                        <br />
                        <span style={{ fontSize: '12px' }}>
                            Period of {FORMAT_DATE(chatData?.periodStartDate)}{' '}
                            to {FORMAT_DATE(chatData?.periodEndDate)}
                        </span>
                        <br />
                        <Tooltip title="Process Remarks">
                            <Pin
                                onClick={() => {
                                    openRemarksModel(serviceProcessId)
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                        </Tooltip>
                    </div>
                }
                width={500}
                onClose={onClose}
                open={open}
            >
                <StaffCommunication
                    serviceProcessId={serviceProcessId}
                    setProcessChatData={setProcessChatData}
                />
            </Drawer>
            <Modal
                footer={null}
                onCancel={changeCommunictionHistoryModalStatus}
                width={'50%'}
                title={'Commication History'}
                open={comHistorymodel}
            >
                <CommunicationHistory
                    serviceProcessId={serviceProcessId}
                    seletedButton={selectedButtonId}
                    setButtonID={setSelectedButtonId}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changePhoneCallModalStatus}
                width={'35%'}
                title={'Phone Call'}
                open={PhoneCallModel}
            >
                <ToDoPhoneCallModel
                    serviceProcessId={serviceProcessId}
                    changePhoneCallModalStatus={changePhoneCallModalStatus}
                    businessTypeId={businessTypeId}
                    resetData={restData}
                    setDataReset={setDataReset}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeSMSModalStatus}
                width={'35%'}
                title={'Send SMS'}
                open={SMSModel}
            >
                <SMSModelPage
                    serviceProcessId={serviceProcessId}
                    changeModalStatus={changeSMSModalStatus}
                    resetData={restData}
                    setDataReset={setDataReset}
                />
            </Modal>

            <Modal
                footer={null}
                onCancel={changeMailModalStatus}
                width={'35%'}
                title={'Send Email'}
                open={mailmodel}
            >
                <MailTempalteModel
                    serviceProcessId={serviceProcessId}
                    changeModalStatus={changeMailModalStatus}
                    serviceId={serviceId}
                    emailPageShow={1}
                    modeId={id}
                    resetData={restData}
                    setDataReset={setDataReset}
                    businessId={businessTypeId}
                    referenceId={referenceId}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeSwitchUserModalStatus}
                width={'35%'}
                title={'Switch User'}
                open={switchUserModel}
            >
                <SwitchUserPage
                    serviceId={10}
                    serviceProcessId={serviceProcessId}
                    changeModalStatus={changeSwitchUserModalStatus}
                    updateRefetchData={updateRefetchData}
                    modeId={id}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeInvoiceModalStatus}
                width={'35%'}
                title={'Create Invoice'}
                open={invoiceModel}
            >
                <InvoiceModel
                    serviceProcessId={serviceProcessId}
                    changeModalStatus={changeInvoiceModalStatus}
                    referenceId={referenceId}
                    resetData={restData}
                    setDataReset={setDataReset}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeVoidModalStatus}
                width={'35%'}
                title={'Void this process'}
                open={voidThisModel}
            >
                <VoidThisProcess
                    changeModelState={changeVoidModalStatus}
                    serviceProcessId={serviceProcessId}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeHoldModalStatus}
                width={'35%'}
                title={'Hold this process'}
                open={holdThisModel}
            >
                <HoldThisProcess
                    changeModelState={changeHoldModalStatus}
                    serviceProcessId={serviceProcessId}
                    flagIds={serviceFlagId}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={ChengeDueDateModelClose}
                width={'45%'}
                title={`Change Due Date`}
                open={changeDueDateModel}
            >
                <ChangeDueDateModel
                    serviceProcessId={serviceProcessId}
                    changeModelState={ChengeDueDateModelClose}
                    resetData={restData}
                    setDataReset={setDataReset}
                />
            </Modal>
            <Modal
                footer={null}
                onCancel={changeRemarksModalStatus}
                width={'45%'}
                title={'Process Remarks'}
                open={remarksModel}
            >
                {auditdata !== null && (
                    <ProcessRemarks
                        auditdata={auditdata}
                        serviceId={serviceId}
                        serviceProcessId={serviceProcessId}
                        changeModalStatus={changeRemarksModalStatus}
                        businessType={businessTypeId}
                        referenceId={referenceId}
                        modeId={0}
                    />
                )}
            </Modal>
        </>
    )
}

export default ConformationStatement
